export default "__VITE_ASSET__C8X8ml0v__"